import React, { useMemo, useState } from "react";
import { Card, CardBody, Tooltip, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { TOM_STATUS_LIST } from "src/modules/data-protection/constants";
import { getTomDisplayId, getTomId } from "../../../../toms/utils/tomIdentifiers";

const RecentActivityWidget = ({ data = [], t, isFetching }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const dateUtils = new DateUtils();

  const rows = useMemo(() => {
    return (data || []).map((item) => {
      const statusConfig = TOM_STATUS_LIST[item.status.toUpperCase()] || null;

      return {
        displayId: getTomDisplayId(item),
        tom: getTomId(item),
        name: item.name,
        status: item.status,
        statusTitle: statusConfig?.title || item.status || "-",
        statusColor: statusConfig?.backgroundColor || "#8B8B8B",
        updated_at: item.updated_at
          ? dateUtils.convertTimeStampToDate(
              item.updated_at,
              INTERNATIONAL_DATE_FORMAT
            )
          : "-",
      };
    });
  }, [data]);

  const columns = [
    {
      dataField: "displayId",
      text: t("TOM ID"),
      sort: true,
      formatter: (cell, row) => (
        <Link
          className="text-primary"
          to={`/admin/data-protection/toms/${row.tom}/details?tab=tom`}
        >
          {cell}
        </Link>
      ),
      style: {
        whiteSpace: "nowrap",
        width: "100px",
      },
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "name",
      text: t("Name"),
      sort: true,
      formatter: (cell, row) => (
        <Link
          className="text-dark"
          to={`/admin/data-protection/toms/${row.tom}/details?tab=tom`}
        >
          {cell}
        </Link>
      ),
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      dataField: "statusTitle",
      text: t("Status"),
      sort: true,
      formatter: (cell, row) => (
        <div
          pill
          style={{
            fontSize: "10px",
            backgroundColor: row.statusColor,
            color: "#fff",
            fontWeight: 700,
            padding: "3px 8px",
            background: row.statusColor,
            opacity: row?.opacity || 1,
            textAlign: "center",
            color: "#FFFFFF",
            borderRadius: "7px",
            whiteSpace: "nowrap",
            width: "78.83px",
            height: "21.59px",
          }}
        >
          {t(cell)}
        </div>
      ),
      style: {
        whiteSpace: "nowrap",
      },
    },
    {
      dataField: "updated_at",
      text: t("Updated At"),
      sort: true,
      style: {
        whiteSpace: "nowrap",
      },
    },
  ];

  const paginationOptions = {
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    sizePerPage: 5,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: t("All"), value: rows.length || 1 },
    ],
  };

  if (isFetching) {
    return (
      <div
        className="dt-field dt-skeleton"
        style={{ width: "100%", height: "320px" }}
      />
    );
  }

  return (
    <Card className="card_box_Shadow h-100">
      <CardBody>
        <h4 className="card-title mb-4">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>{t("Recent Activity")}</div>

            <i
              className="fa fa-info-circle"
              aria-hidden="true"
              id="infoIconRecentActivity"
            />
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target="infoIconRecentActivity"
              toggle={() => setTooltipOpen((prev) => !prev)}
            >
              {t("Shows the latest updated TOMs.")}
            </Tooltip>
          </div>
        </h4>

        <div
          className="table-responsive"
          style={{ overflowX: "hidden", maxWidth: "100%" }}
        >
          <BootstrapTable
            keyField="tom"
            data={rows}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            noDataIndication={t("No recent activity found.")}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default RecentActivityWidget;
